import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="35" height="31" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 30.066V14.31L15.756.877v29.189H0zm18.786 0V14.31L34.542.877v29.189H18.786z" fill="#6d6c6c" fillRule="evenodd" /></svg>);